import request from 'utils/request'
import storage from 'utils/storage'
import { inputHandler } from 'utils/eventHandlers'

const { REACT_APP_API_URL: API_URL } = process.env

export const initialState = {
  email: '',
  password: ''
}

const submitHandler = api => event => {
  event.preventDefault()
  request.post(API_URL + '/account', api.state)
    .then(({ token }) => {
      storage.setToken(token)
      api.props.navigate('/')
    })
  api.setState(initialState)
}

export default api => ({
  change: inputHandler(api),
  submit: submitHandler(api)
})
